<div class="card-view-primary-box app-scrollbar">
  <div class="header row align-items-center">
    <div class="col-11 d-flex align-items-end">
      <div class="col-12 d-flex align-items-center">
        <img src="assets/svg/icon-user-key-circle.svg" alt="key icon" />

        <span class="count pr-10 pl-12">
          {{ shareAccess?.totalCount }}
        </span>

        <div class="dashboard-card-header">
          {{ 'SHARED_ACCESS' | translate }}
        </div>
      </div>
    </div>
    <hr class="col-12 divider" />
  </div>

  <div class="content position-relative">
    <ng-container *ngIf="shareAccess?.access?.length === 0">
      <p class="no-record">
        {{ 'RECORD_NOT_FOUND' | translate }}
      </p>
    </ng-container>
    <ng-container *ngIf="shareAccess?.access?.length > 0">
      <div
        class="main-containter"
        *ngFor="let shareAccessObj of shareAccess?.access"
      > 
      <ng-container *appHideAccess="commonAccessControl">
        <a *ngIf="shareAccessObj?.accessPointId" class="user-item">
          <div class="row py-2 mx-2 item pointer-cursor">
            <div class="col-7">
              <div *ngIf="shareAccessObj?.unitName" class="col-12 heading3">
                {{ 'UNIT' | translate }}
                {{ shareAccessObj?.unitPrefix + shareAccessObj?.unitName }}
              </div>
              <div
                *ngIf="shareAccessObj?.accessPointName"
                class="col-12 heading3"
              >
                <div class="col-12 dashboard-list-content">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ shareAccessObj?.accessPointName }}</app-with-tooltip
                  >
                </div>
              </div>
              <div class="col-12 status">
                {{ shareAccessObj?.buildingName }}
              </div>
            </div>
            <div
              class="col-5 px-1 text-right align-self-center"
              (click)="onClickAccess(shareAccessObj)"
            >
              <span class="time">
                <strong>{{ shareAccessObj?.userCount }}</strong>
              </span>
              <img src="assets/svg/ico-chevron-forward-outline.svg" />
            </div>
          </div>
        </a>
        </ng-container>

        <ng-container *ngIf="shareAccessObj?.unitId">
          <a class="user-item">
            <div class="row py-2 mx-2 item pointer-cursor">
              <div class="col-7">
                <div *ngIf="shareAccessObj?.unitName" class="col-12 heading3">
                  {{ 'UNIT' | translate }}
                  {{ shareAccessObj?.unitPrefix + shareAccessObj?.unitName }}
                </div>
                <div
                  *ngIf="shareAccessObj?.accessPointName"
                  class="col-12 heading3"
                >
                  <div class="col-12 dashboard-list-content">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ shareAccessObj?.accessPointName }}</app-with-tooltip
                    >
                  </div>
                </div>
                <div class="col-12 status">
                  {{ shareAccessObj?.buildingName }}
                </div>
              </div>
              <div
                class="col-5 px-1 text-right align-self-center"
                (click)="onClickAccess(shareAccessObj)"
              >
                <span class="time">
                  <strong>{{ shareAccessObj?.userCount }}</strong>
                </span>
                <img src="assets/svg/ico-chevron-forward-outline.svg" />
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <a
  
    class="view-all-btn d-flex justify-content-center align-items-center "
    [ngClass]="
      shareAccess?.access?.length > dashboardManagementService.maxCardRecords
        ? 'visible'
        : 'invisible'
    "
  >
  <span (click)="openViewAllModal()" >
    <p 
    class="mt-1 mb-0 pointer-cursor">{{ 'VIEW_ALL' | translate }}</p>
  </span>
    
  </a>
</div>
